export default "__VITE_ASSET__CV$lPIMS__"